<template>
  <v-sheet class="c-calendar-bar" :class="shsc.CLASS">
    <div class="whitespace-no-wrap" :style="{width, height: '96px'}">
      <c-cell
        v-for="(date, index) in dates"
        :key="date"
        :date="calendar[date]"
        :state="states[date]"
        :anytime="anytime"
        :show-month="index === 0 || calendar[date].day === 1"
        @selected="$emit('selected', $event)"
      />
    </div>
  </v-sheet>
</template>

<style lang="scss">
.c-calendar-bar {
  overflow-x: scroll;
  /*
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
  */
}
</style>

<script>
import CCell from './CCell'

import SyncHScroll from '../../SyncHScroll'

export default {
  name: 'CCalendarBar',
  components: {
    CCell
  },
  mixins: [
    SyncHScroll.Client
  ],

  props: {
    dates: Array,
    calendar: Object,
    states: Object,
    anytime: Number
  },
  computed: {
    width () {
      const len = this.dates ? this.dates.length : 0
      return `${32 * len}px`
    }
  }
}
</script>
